import {createI18n} from 'vue-i18n';
import sk from '@/../locales/sk.json';

const i18n = createI18n({
    locale: 'sk',
    messages: {
        sk
    }
});

export default i18n;
